// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileNotification_wrapper__I9Yvd","label":"ProfileNotification_label__OQdiG","title":"ProfileNotification_title__+3Uq9"};